import React, { useContext, useEffect, useState } from 'react'
import './Coin.css';
import Navbar from '../../Components/Navbar/Navbar'
import Footer from '../../Components/Footer/Footer'
import { useParams } from 'react-router-dom'
import myContext from '../../Context/Context';
import LineChart from '../../Components/LineChart/LineChart';

function Coin() {
  const {currency} = useContext(myContext);
  const {coinId}=useParams();
  const [coinData,setCoinData]=useState();
  const [chartdata,setChartdata]=useState();
  useEffect(()=>{
    const options = {
      method: 'GET',
      headers: {accept: 'application/json', 'x-cg-demo-api-key': 'CG-rvbivjuMfidcYPN37BQ34rds'}
    };
    
    fetch(`https://api.coingecko.com/api/v3/coins/${coinId}`, options)
      .then(res => res.json())
      .then(res => setCoinData(res))
      .catch(err => console.error(err));
  },[coinId]);
  useEffect(()=>{
    const options = {
      method: 'GET',
      headers: {accept: 'application/json', 'x-cg-demo-api-key': 'CG-rvbivjuMfidcYPN37BQ34rds'}
    };
    
    fetch(`https://api.coingecko.com/api/v3/coins/${coinId}/market_chart?vs_currency=${currency.name}&days=10`, options)
      .then(res => res.json())
      .then(res => setChartdata(res))
      .catch(err => console.error(err));
  },[coinId,currency.name])
  return (
    <>
    <Navbar/>
    
    {
      coinData && chartdata ? 
      <div>
        <div className='container'>
          <div className='row'>
            <div className='col-12'>
            <h4 className='coin_name'><img className='coin_img' src={coinData.image.thumb} alt={coinData.name}/>{coinData.id} <span>#{coinData.market_cap_rank}</span></h4>
              <div className='price'>
              <h2>{currency.symbol} {coinData.market_data.current_price[currency.name]}</h2>
              <div className='d-flex gap-1'>
              {coinData.market_data.price_change_percentage_24h>0? <span><i className="fa-solid fa-caret-up green2"></i></span> :<span><i className="fa-solid fa-caret-down red2"></i></span>}
              <p className={coinData.market_data.price_change_percentage_24h>0?"green2":"red2"}>{Math.floor(coinData.market_data.market_cap_change_percentage_24h_in_currency[currency.name]*100)/100}%</p>
              </div>
              </div>
            </div>
            <div className='col-md-5'>
              <hr/>
              <div className='portfolio'>
                <h5>Portfolio</h5>
                <p><span>Market Cap</span><span>{currency.symbol} {coinData.market_data.market_cap[currency.name]}</span></p>
                <p><span>Fully Diluted Valuation</span><span>{currency.symbol} {coinData.market_data.fully_diluted_valuation[currency.name]}</span></p>
                <p><span>24 Hour Trading Vol</span><span>{currency.symbol} {coinData.market_data.high_24h[currency.name]}</span></p>
                <p><span>Circulating Supply</span><span>{currency.symbol} {coinData.market_data.market_cap[currency.name]}</span></p>
                <p><span>Total Supply</span><span>{currency.symbol} {coinData.market_data.total_supply}</span></p>
                <p><span>Max Supply </span><span>{currency.symbol} {coinData.market_data.max_supply}</span></p>
              </div>
              <hr/>
              <div className='history'>
                <h5>BTC Historical Price</h5>
                <p><span>Price Change 24h</span><span>{currency.symbol} {coinData.market_data.price_change_percentage_24h_in_currency[currency.name]}%</span></p>
                <p><span>Price Change 7d</span><span>{currency.symbol} {coinData.market_data.price_change_percentage_7d_in_currency[currency.name]}%</span></p>
                <p><span>All-Time High</span><span>{currency.symbol} {coinData.market_data.high_24h[currency.name]}</span></p>
                <p><span>All-Time Low</span><span>{currency.symbol} {coinData.market_data.low_24h[currency.name]}</span></p>
              </div>
            </div>
            <div className='col-md-7'>
              <div className='coin_chart'>
                <LineChart chartdata={chartdata}/>
              </div>
              <div className='mt-3'>
              <h6>About :</h6>
                <p>{coinData.description.en.slice(0,1000)}...</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      :
      <div>
        <div className='spinner'>
          <div className='spin'>
            
          </div>
        </div>
      </div> 
      }
    <Footer/>
    </>
  )
}

export default Coin